<template>
  <div>
    <template v-if="successFullyUploaded == true">
      <v-card-text>
        <div class="pa-4 text-center">
          <div class="d-flex justify-center">
            <v-icon size="96" color="success">mdi-check-circle-outline</v-icon>
          </div>
          <span class="caption"
            ><lang t="ARTICLES-IMPORT-SUCCESSFULLY_IMPORTED"></lang
          ></span>
          <br />
          <v-btn text @click="closeModal" :disabled="isSaving"
            ><lang t="GLOBAL-BTN-CLOSE"></lang
          ></v-btn>
        </div>
      </v-card-text>
    </template>

    <template v-else>
      <v-card-text>
        <template v-if="!isUploading && uploadedData == null">
          <v-file-input
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :prepend-icon="false"
            :append-icon="fileInputIcon"
            flat
            solo
            ref="importFile"
            height="48px"
            background-color="themeColor"
            :label="$t('ARTICLES-UPLOAD_FILE')"
            :loading="isUploading"
            @change="fileUpload($event)"
            @click:append="appendedIconClicked"
            style="max-width:360px;"
            class="ma-auto"
          >
          </v-file-input>
        </template>

        <template v-else-if="isUploading">
          <div class="d-flex flex-column align-center justify-center">
            <v-progress-linear
              style="max-width: 480px;"
              color="themeColor accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
            <lang
              t="ARTICLES-IMPORT-PROCESSING_DATA"
              class="text-caption"
            ></lang>
          </div>
        </template>

        <template v-else-if="isImporting">
          <div
            class="d-flex align-center justify-center flex-column"
            style="min-height: 400px;"
          >
            <v-progress-linear
              style="max-width: 640px;"
              color="themeColor accent-4"
              :value="importStatus"
              readonly
              height="25"
            >
              <template v-slot:default="{ value }">
                <strong>{{ Math.ceil(value) }}%</strong>
              </template>
            </v-progress-linear>
            <br>
            <p>{{ importProgressMessage }}</p>
          </div>
        </template>

        <template v-else>
          <v-card
            class="d-flex"
            color="grey lighten-3 mx-2"
            flat
            tile
            style="overflow-y: auto;"
          >
            <div
              v-for="(value, key, colIndex) in uploadedData.headers"
              style="min-width: 250px;"
              :class="['col pa-3', { isAssigned: hasAssignedField(key) }]"
              :key="key"
            >
              <div class="colHead pb-2 mb-2">
                <div class="colTitle mb-1">
                  {{ key }}
                </div>

                <div class="mb-1">
                  <v-select
                    :hide-details="true"
                    :items="availableFields"
                    :value="value"
                    @change="selectNewColName($event, key)"
                    :label="false"
                    dense
                    outlined
                    style="font-size:12px;"
                  ></v-select>
                  <v-select
                    v-if="uploadedData.headers[key] == 'gtin'"
                    :hide-details="true"
                    :items="gtinFormats"
                    v-model="gtinFormat"
                    :label="false"
                    dense
                    outlined
                    style="font-size:12px;"
                    class="mt-1"
                  ></v-select>
                </div>
              </div>
              <div
                class="colContent"
                v-for="(data, dataIndex) in uploadedData.exampleData"
              >
                {{ data[colIndex] }}
              </div>
            </div>
          </v-card>
        </template>
      </v-card-text>

      <v-card-actions v-if="!isImporting">
        <v-spacer></v-spacer>
        <v-btn text @click="closeModal()" :disabled="isImporting"
          ><lang t="GLOBAL-BTN-CANCEL"></lang
        ></v-btn>
        <v-btn
          elevation="0"
          light
          rounded
          color="themeColor"
          @click="startImport"
          :loading="isImporting"
          v-if="uploadedData != null"
          ><lang t="ARTICLES-IMPORT-BTN-IMPORT"></lang
        ></v-btn>
      </v-card-actions>
    </template>
    <v-dialog v-model="showRequiredDialog" max-width="450px"  :persistent="false">
        <v-card>
          <v-card-title>
            <span :class="`title1`">{{ $t('IMPORT-REQUIRED-DIALOG-TITLE') }}</span>

            <v-spacer></v-spacer>
    
          </v-card-title>
          <v-card-text class="">
              <div>
                <p style="padding: .25em 0;">{{ $t('ARTICLES-IMPORT-DIALOG-REQUIRED-DESCRIPTION') }}</p>
              </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="0" light rounded color="themeColor" @click="showRequiredDialog = false"
              ><lang t="ARTICLES-IMPORT-BTN-CONFIRM"></lang
            ></v-btn>
          </v-card-actions>
        </v-card>
   </v-dialog>
    <v-dialog v-model="showLevelDialog" max-width="450px"  :persistent="false">
        <v-card>
          <v-card-title>
            <span :class="`title1`">{{ $t('IMPORT-LEVEL-DIALOG-TITLE') }}</span>

            <v-spacer></v-spacer>

            <v-btn icon light @click="showLevelDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="">
              <div>
                <p style="padding: .25em 0;">{{ $t('ARTICLES-IMPORT-DIALOG-LEVEL-DESCRIPTION') }}</p>
                <v-select
                            :items="levels"
                            item-text="text"
                            item-value="value"
                            :label="$t('ARTICLES-IMPORT-FIELD-LEVEL')"
                            v-model="selectedLevel"
                          />
              </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text  @click="showLevelDialog = false"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="importArticles()" :loading="isSaving"
              ><lang t="ARTICLES-IMPORT-BTN-IMPORT"></lang
            ></v-btn>
          </v-card-actions>
        </v-card>
   </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'articleImporter',
  props: {
    warehouseId: {
      type: Number,
      default: null,
    },
    visible:{
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isImporting: false,
      isUploading: false,
      uploadedData: null,
      availableFields: null,
      newColumns: null,
      successFullyUploaded: false,
      selectedLevel: 'case',
      showLevelDialog: false,
      showRequiredDialog: false,
      totalRecords: 0,
      importStatus: null,
      importProgressMessage: '',
      refreshIntervalId: null,
      gtinFormat: "00000000000000",

      gtinFormats: [
        {
          text: this.$t("ARTICLES-IMPORT-FIELD-GTIN_FORMAT-COMPLETE"),
          value: "00000000000000",
        },
        {
          text: this.$t("ARTICLES-IMPORT-FIELD-GTIN_FORMAT-LAST_TWO_MISSING"),
          value: "000000000000**",
        },
      ],
    };
  },
  watch:{
    visible: function(status){
        this.resetData();
    },
  },
  computed: {
    fileInputIcon() {
      return this.isUploading ? "" : "mdi-upload";
    },
    levels(){
     return [
        {value: 'case', text: this.$t('IMPORT-LEVEL-CASE')},
        {value: 'pack', text: this.$t('IMPORT-LEVEL-PACK')},
        {value: 'unit', text: this.$t('IMPORT-LEVEL-UNIT')},
     ];
    }
  },
  methods: {
    hasAssignedField(key) {
      return this.uploadedData.headers[key] != null;
    },

    selectNewColName(value, key) {
      this.uploadedData.headers[key] = value;
    },

    resetData(){
      this.newColumns = null;
      this.isUploading = false;
      this.uploadedData = null;
      this.availableFields = null;
      this.showLevelDialog = false;
      this.successFullyUploaded = false;
      this.importProgressMessage = '';
      this.showRequiredDialog = false;
      this.isImporting = false;
      this.importStatus = 0;
    },

    closeModal() {
      this.resetData();
      this.$emit("closeModal");
    },

    fileUpload(file) {
      this.isUploading = true;

      if (typeof file == "undefined") {
        return;
      }

      let formData = new FormData();
      formData.append("file", file, file.name);

      // additional data
      formData.append("key", "file");

      this.axios
        .post("items/upload", formData)
        .then((response) => {
          setTimeout(() => {
            this.$emit("changeToFullScreen");

            this.totalRecords = response.data.total;
            this.availableFields = [];

            // add new select option "do not import"
            this.availableFields.push({
              text: this.$t("ARTICLES-IMPORT-FIELD-DO_NOT_IMPORT"),
              value: null,
            });

            response.data.availableFields.forEach((f) => {
              this.availableFields.push({
                text: this.$t("ARTICLES-IMPORT-FIELD-" + f.toUpperCase()),
                value: f,
              });
            });

            this.isUploading = false;
            this.uploadedData = response.data;
          }, 0);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    appendedIconClicked() {
      this.$refs.importFile.$el.querySelector("input").click();
    },

    startImport(){

      let mappings = JSON.parse(JSON.stringify(this.uploadedData.headers));

      for (var key in mappings) {
        if (mappings[key] == null) {
          delete mappings[key];
        }
      }
      
      const mappingValues = Object.values(mappings);
      if(mappingValues && mappingValues.length > 0){
        let hasRequiredName = false;
        let hasRequiredGTIN = false;
        mappingValues.forEach(el => {
          if(el ==='name'){
            hasRequiredName = true;
          }
          if(el === 'gtin'){
            hasRequiredGTIN = true;
          }
        });
        if(!hasRequiredGTIN || !hasRequiredName){
          return this.showRequiredDialog = true;
        }
        const hasLevelMapping = mappingValues.some(el => el === 'level');
        if(!hasLevelMapping) {
          return this.showLevelDialog = true;
        }
      }
      this.importArticles();
    },

    importArticles() {
      clearInterval(this.refreshIntervalId);
      this.showLevelDialog = false;
      this.showRequiredDialog = false;
      this.isImporting = true;
      this.importStatus = 0;
      let status = 0;
      let mappings = JSON.parse(JSON.stringify(this.uploadedData.headers));

      for (var key in mappings) {
        if (mappings[key] == null) {
          delete mappings[key];
        }
      }

      let importData = {
        warehouse_id: this.warehouseId,
        filename: this.uploadedData.filename,
        mapping: mappings,
        gtinFormat: this.gtinFormat,
        offset: 0,
        limit: 400,
        async: true
      };

      const mappingValues = Object.values(mappings);
      if(mappingValues && mappingValues.length > 0){
        const hasLevelMapping = mappingValues.some(el => el === 'level');
        if(!hasLevelMapping && this.selectedLevel) {
          importData["level"] = this.selectedLevel;
        }
      }

       this.axios.post("items/import", importData).then((res) => {
          const importKey = res.data.key;

        this.refreshIntervalId = setInterval(() => {
          this.axios.get("items/import/status/" + importKey).then((resp) => {
            // case error
            if (resp.data.error) {
               this.$store.dispatch("setSnackbar", {
                  text: resp.data.error,
                  type: "error",
                });
              clearInterval(this.refreshIntervalId);
            }else {
              if(resp.data && resp.data.progress !== undefined && resp.data.message !== undefined){
                this.importStatus = resp.data.progress*100;
                this.importProgressMessage = resp.data.message;
                if(this.importStatus >= 100){
                  this.importStatus = 100;
                  this.successFullyUploaded = true;
                  this.isImporting = false;
                  clearInterval(this.refreshIntervalId);
                  setTimeout(() => {
                      this.closeModal();
                  }, 2000);
                }
              }
               
            }
          });
        }, 1000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.col {
  color: #bbb;

  &.isAssigned {
    background-color: lighten(#ffed00, 30%);
    color: #000;
  }

  &:not(:last-child) {
    border-right: 1px dotted #ddd;
  }
  &:last-child {
    border-right: none !important;
  }

  .colHead {
    border-bottom: 1px solid #ddd;
    min-height: 135px;

    .colTitle {
      font-size: 12px;
      line-height: 16px;
      font-weight: bold;
      min-height: 32px;
    }
  }
  .colContent {
    font-size: 12px;
  }
}
</style>
